export enum StorageKeys {
    MINI_MENU = 'miniMenu',
    DARK_MODE = 'darkMode',
}
